<section class="no-results wow fadeInUp">
  <div class="row center-xs middle-xs">
    <div class="col-xs-12">
      <i class="no-results-icon icon-form"></i>
    </div>
    <p *ngIf="noDataStr" class="no-results-text col-xs-12">{{ noDataStr }}</p>
    <div *ngIf="canEdit" class="col-xs-12">
      <button id="btn-start-form" class="btn-primary" (click)="addFirst.emit()">
        {{ addStr }}
      </button>
    </div>
  </div>
</section>
